import { isBinaryInteractiveConfirmPhrase } from './binaryConfirmPhrase'

/** When false, keep raw/ordinal/yes-no text; skip Nova Lite for display overrides. */
export function shouldNormalizeTypedCommand(
  trimmed: string,
  opts?: { displayText?: string },
): boolean {
  const t = trimmed.trim()
  if (!t) return false
  if (opts?.displayText && opts.displayText.trim() !== t) return false
  if (/^\d{1,2}$/.test(t)) return false
  if (/^(oui|non|yes|no|ok|annuler|cancel)$/i.test(t)) return false
  if (isBinaryInteractiveConfirmPhrase(t)) return false
  return true
}
